<template>
  <div class="vendor-performance-wrapper">
    <ul
      class="accordion accordion-customize"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
      id="vendor-performance-accordion"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a class="accordion-title"><span>{{ $t('company.titles.vendorPerformance') }}</span></a>
        <div
          class="accordion-content"
          data-tab-content
        >
          <!-- <div class="vendor-history">
              <router-link :to="{name: 'tenders', query: {vendorId: companyId}}">{{ $t('settings.user.vendor.history') }}</router-link>
          </div> -->
          <div class="clearfix search-section">
            <div class="select-trade">
              <label class="emphasis">{{ $t('company.performance.trade') }}</label>
              <HKLMultiSelect
                :value="searchCriteria.trade"
                :options="tradeHklOptions"
                placeholder=""
                @change="val => { searchCriteria.trade = val }"
              />
            </div>
            <div class="select-building">
              <label class="emphasis">{{ $t('company.performance.site') }}</label>
              <HKLMultiSelect
                :value="searchCriteria.site"
                :options="siteHklOptions"
                placeholder=""
                @change="val => { searchCriteria.site = val }"
              />
            </div>
            <div class="select-date-range">
              <label class="emphasis">{{ $t('company.performance.dateRange') }}</label>
              <div class="date-picker">
                <DatePicker
                  class="columns date-range-picker"
                  :calendarButton="true"
                  calendarButtonIcon="fa fa-calendar"
                  v-model="searchCriteria.startDay"
                  placeholder="From"
                  :disabled="{from: searchCriteria.endDay || new Date()}"
                />
              </div><!--
              --><div class="date-picker second-picker">
                <DatePicker
                  class="columns date-range-picker"
                  :calendarButton="true"
                  v-model="searchCriteria.endDay"
                  calendarButtonIcon="fa fa-calendar"
                  placeholder="To"
                  :disabled="{from: new Date(), to: searchCriteria.startDay}"
                />
              </div>
              <div class="search-button">
                <button
                  class="btn btn--orange"
                  @click="searchPerformance()"
                >{{ $t('company.performance.apply') }}</button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-5 medium-5 large-5 column">
              <div class="column-wrapper">
                <ProjectPerformance
                  :tenders="tenders"
                  :projects="projects"
                  :startDay="searchCriteria.startDay"
                  :endDay="searchCriteria.endDay"
                  :companyId="companyId"
                  :description="companyName"
                  :site="searchCriteria.site"
                  :trade="searchCriteria.trade"
                />
              </div>
            </div>
            <div class="small-7 medium-7 large-7 column">
              <div class="column-wrapper">
                <QuotationKpi
                  :tendersData="tenders"
                  :companyId="companyId"
                  :projects="projects"
                  :startDay="searchCriteria.startDay"
                  :endDay="searchCriteria.endDay"
                  :purchaseAmounts="purchaseAmounts"
                />
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { ONE_DAY_MILLI } from '@/utils/dateUtil'

import DatePicker from '@/controls/DatePicker'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'
import QuotationKpi from './QuotationKPI'
import ProjectPerformance from './ProjectPerformance'
import { expandTradeCategories, getPerformanceData, normalizeTradeCategorySelections, setupOptions } from '@/api/performance/request'
import { projectStatus } from '@/utils/locale'
import mutationTypes from '@/store/mutation-types'

export default {
  name: 'VendorPerformance',
  data () {
    const tradeOptions = ['All']
    return {
      tenders: [],
      projects: [],
      purchaseAmounts: [],
      sitesOptions: [],
      tradeOptions,
      tradeCategoryMap: {},
      searchCriteria: { site: [], trade: [], startDay: null, endDay: null },
      data: [],
    }
  },
  components: {
    HKLMultiSelect,
    DatePicker,
    ProjectPerformance,
    QuotationKpi,
  },
  methods: {
    ...mapMutations('ccd', {
      setSearchConditions: mutationTypes.PERFORMANCE_SEARCH_CONDITIONS,
    }),
    endOfDay (date) {
      return new Date(date.getTime() + ONE_DAY_MILLI - 1)
    },
    normalizeTradeSearchValue () {
      this.searchCriteria.trade = normalizeTradeCategorySelections(
        this.searchCriteria.trade || [],
        this.tradeOptions || [],
      )
    },
    getExpandedTradeCategories () {
      return expandTradeCategories(
        this.searchCriteria.trade || [],
        this.tradeCategoryMap,
      )
    },
    async searchPerformance () {
      if (!this.companyId) {
        return
      }

      const query = {
        startDay: this.searchCriteria.startDay,
        endDay: this.searchCriteria.endDay && this.endOfDay(this.searchCriteria.endDay),
        site: (this.searchCriteria.site || []).join(','),
        category: this.getExpandedTradeCategories().join(','),
        companyId: this.companyId,
      }
      const performanceData = await getPerformanceData(query)
      this.tenders = lodash.get(performanceData[this.companyId], 'tenders', [])
      this.projects = lodash.get(performanceData[this.companyId], 'projects', []).filter(item => item.status !== projectStatus.CANCELLED, [])
      this.purchaseAmounts = lodash.get(performanceData[this.companyId], 'purchaseAmounts', [])
    },
    initSearchCriteria () {
      const searchCondition = lodash.cloneDeep(this.performanceSearchConditions)
      this.description = lodash.get(searchCondition, 'name.value', '')
      this.$set(this.searchCriteria, 'startDay', lodash.get(searchCondition, 'dateRange.value[0]'))
      this.$set(this.searchCriteria, 'endDay', lodash.get(searchCondition, 'dateRange.value[1]'))
      this.searchCriteria.site = lodash.get(searchCondition, 'site.value', [])
      this.searchCriteria.trade = lodash.get(searchCondition, 'trade.value', [])
    },
  },
  computed: {
    ...mapGetters('ccd', ['currentCompany', 'performanceSearchConditions']),
    companyId () {
      return this.$router.currentRoute.params.id
    },
    companyName () {
      return this.currentCompany && this.currentCompany.name
    },
    tradeHklOptions () {
      return (this.tradeOptions || []).map((trade) => ({ name: trade, value: trade }))
    },
    siteHklOptions () {
      return (this.sitesOptions || []).map((site) => ({ name: site, value: site }))
    },
  },
  async mounted () {
    if (!this.companyInfoAccordion) {
      this.companyInfoAccordion = new Foundation.Accordion(
        $('#vendor-performance-accordion'),
      )
    }
    this.initSearchCriteria()
    const options = await setupOptions(this.companyId)
    this.sitesOptions = options.sites
    this.tradeOptions = options.categories
    this.tradeCategoryMap = options.categoryMap || {}
    this.normalizeTradeSearchValue()
    this.searchPerformance()
  },
  beforeDestroy () {
    this.setSearchConditions({searchConditions: {
      dateRange: { value: [this.searchCriteria.startDay, this.searchCriteria.endDay] },
      site: { value: this.searchCriteria.site },
      trade: { value: this.searchCriteria.trade },
    }})
  },
  destroyed () {
    if (this.companyInfoAccordion) {
      this.companyInfoAccordion.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/tender/view";
@import "~styles/accordion";

.select-building, .select-trade {
  float: left;
  margin-right: 30px;
}

.vendor-history {
  float: left;
  padding-top: 50px;
  font-family: Verdana;
  font-size: 18px;
  font-weight: bold;
  a {
    padding-left: 0px;
    color:#1779ba;
    text-decoration: underline;
  }
}

.select-date-range {
  float: left;
  &>.date-picker {
  display: inline-block;
  }
  .columns.date-range-picker {
    width: 140px;
  }
}

.search-button {
  float: right;
  margin-left: 30px;
}

.second-picker {
  margin-left: -1px;
}

.column-wrapper {
  background: #f8f8f8;
}

.row .column {
  &:not(:last-of-type) {
    padding-right: 20px;
  }
}
</style>

<style lang="scss">
$height: 35px;

.vendor-performance-wrapper {
  .search-section {
    float: right;
  }
  .select-building, .select-trade {
    min-width: 200px;
    width: auto;
  }
}
</style>
